import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import './Profile.css';

const Profile: React.FC = () => {
  const { t, i18n } = useTranslation();
  const [email, setEmail] = useState('user@example.com');
  const [language, setLanguage] = useState(i18n.language);

  const handleLanguageChange = (lang: string) => {
    setLanguage(lang);
    i18n.changeLanguage(lang);
  };

  return (
    <div className="page-container">
      <div className="page-header">
        <h1>Профиль</h1>
        <p style={{ color: '#9ca3af', marginTop: '8px' }}>
          Управление вашим аккаунтом и настройками
        </p>
      </div>

      <div className="profile-content">
        {/* Account Information */}
        <div className="card">
          <h2>Информация об аккаунте</h2>
          <div className="form-section">
            <div className="form-group">
              <label>Email</label>
              <input
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder="your@email.com"
              />
            </div>

            <div className="form-group">
              <label>Язык интерфейса</label>
              <select value={language} onChange={(e) => handleLanguageChange(e.target.value)}>
                <option value="ru">Русский</option>
                <option value="en">English</option>
                <option value="zh">中文</option>
                <option value="ar">عربي</option>
              </select>
            </div>

            <button className="primary">Сохранить изменения</button>
          </div>
        </div>

        {/* Subscription */}
        <div className="card">
          <h2>Подписка</h2>
          <div className="subscription-info">
            <div className="current-plan">
              <div className="plan-badge free">Бесплатный план</div>
              <p>Базовые функции торговли и аналитики</p>
            </div>

            <div className="plan-features">
              <h3>Включено:</h3>
              <ul>
                <li>✓ 1 активный торговый бот</li>
                <li>✓ Базовые стратегии</li>
                <li>✓ История сделок за 30 дней</li>
                <li>✓ Поддержка по email</li>
              </ul>
            </div>

            <div className="upgrade-section">
              <h3>Pro план</h3>
              <p className="price">$29/месяц</p>
              <ul>
                <li>✓ Неограниченное количество ботов</li>
                <li>✓ Продвинутые AI стратегии</li>
                <li>✓ Полная история сделок</li>
                <li>✓ Приоритетная поддержка 24/7</li>
                <li>✓ Расширенная аналитика</li>
              </ul>
              <button className="primary upgrade-btn">Перейти на Pro</button>
            </div>
          </div>
        </div>

        {/* Security */}
        <div className="card">
          <h2>Безопасность</h2>
          <div className="form-section">
            <div className="form-group">
              <label>Изменить пароль</label>
              <input type="password" placeholder="Текущий пароль" />
              <input type="password" placeholder="Новый пароль" style={{ marginTop: '8px' }} />
              <input
                type="password"
                placeholder="Повторите новый пароль"
                style={{ marginTop: '8px' }}
              />
            </div>

            <button className="secondary">Изменить пароль</button>
          </div>

          <div className="danger-zone">
            <h3>Опасная зона</h3>
            <p>Удаление аккаунта необратимо. Все данные будут потеряны.</p>
            <button className="danger">Удалить аккаунт</button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Profile;
